// Which gift tiles this customer sees. Pure so the rules are unit-testable.
//
// The magnet rule is deliberately keyed on hasFreeMagnets -- the cart actually
// HOLDING the offer's free pair -- not on the offer being live: an all-JPG
// session never sees the magnet page (nothing to cut out) and a decliner said
// no; both must still be able to BUY magnets. Only a customer who already has
// the free pair is spared the $29.99 duplicate (review on #5264).
// The magnet CALENDAR stays either way: different product (css_name calendar).
export default function giftAddonVisible(addon, { seniorCustomer = false, hasFreeMagnets = false } = {}) {
  if (addon.cssName === 'sibling') return false;
  if (hasFreeMagnets && addon.cssName === 'magnet') return false;

  // Grad announcements are senior-only products.
  if (addon._attributes.cssName.includes('grad')) return seniorCustomer; // eslint-disable-line no-underscore-dangle

  // Audience-priced rows: the same product exists per audience at different
  // prices (senior wallets $115 vs elementary $39.95) -- show each customer
  // only their audience's row. Unflagged rows are for everyone.
  if (addon.isSenior && !addon.isElementary) return seniorCustomer;
  if (addon.isElementary && !addon.isSenior) return !seniorCustomer;

  return true;
}
